document.addEventListener('DOMContentLoaded', () => {
    initProductFeaturesSlider();
    initReadMore();
});
function initProductFeaturesSlider() {
    const productFeaturesSliders = document.querySelectorAll('.js-product-features-details-slider');

    productFeaturesSliders.forEach(slider => {
        new Swiper(slider, {
            slidesPerView: 1.334,
            spaceBetween: 8,
            navigation: {
                nextEl: slider.parentElement.querySelector('.swiper-arrow-next'),
                prevEl: slider.parentElement.querySelector('.swiper-arrow-prev')
            },
            breakpoints: {
                550: {
                    slidesPerView: 1.8,
                    spaceBetween: 16,
                },
                767: {
                    slidesPerView: 2.2,
                    spaceBetween: 16,
                },
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3
                }
            }
        });
    });
}
function initReadMore() {
    const readMoreButtons = document.querySelectorAll('.features-details-item-read-more');

    readMoreButtons.forEach(button => {
        button.addEventListener('click', () => {
            const item = button.closest('.features-details-item');
            const itemText = item.querySelector('.features-details-item-text');
            const fullText = item.querySelector('.full-text');
            const altText = button.getAttribute('data-alt-text');
            const currentText = button.textContent.trim();

            itemText.classList.toggle('expanded');
            button.textContent = altText;
            button.setAttribute('data-alt-text', currentText);
        });
    });
}
